export const billingItemTypeTag = 'itemType:';
